import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Constants } from './constants';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { NgIdleModule } from '@ng-idle/core';



// mat list,icon,menu
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { AgGridModule } from 'ag-grid-angular';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from "ngx-ui-loader";
import { DatePipe } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from "@angular/material/icon";
import { FlexLayoutModule } from "@angular/flex-layout";


// pages
import { HomeComponent } from './pages/home/home.component';
import { FooterComponent } from 'src/app/core/footer/footer.component';
import { HeaderComponent } from './core/header/header.component';
// import { LoadRouteComponent } from './pages/document-control/load-route/load-route.component';
import { DocumentControlInquiryComponent } from './core/dialogs/document-control-inquiry/document-control-inquiry.component';
import { AddComplianceReviewComponent } from './core/dialogs/add-compliance-review/add-compliance-review.component';
import { BreadcrumbComponent } from './core/breadcrumb/breadcrumb.component';
import { AddEditComplianceManagementComponent } from './core/dialogs/add-edit-compliance-management/add-edit-compliance-management.component';
import { AddContainerConsolidationComponent } from './core/dialogs/add-container-consolidation/add-container-consolidation.component';
//msal
import { MsalService, MSAL_INSTANCE, MsalGuard, MsalInterceptor, MsalBroadcastService } from './msal';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from './msal/constants';
import { MsalGuardConfiguration } from './msal/msal.guard.config';
import { MsalInterceptorConfig } from './msal/msal.interceptor.config';
import { environment } from 'src/environments/environment';
import { UnAuthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { AddBookingInfoComponent } from './core/dialogs/add-booking-info/add-booking-info.component';
import { WarningDialogComponent } from './core/dialogs/warning-dialog/warning-dialog.component';
import { AddLoadTypeComponent } from './core/dialogs/add-load-type/add-load-type.component';
import { EditLpRouteSystemComponent } from './core/dialogs/edit-lp-route-system/edit-lp-route-system.component';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.CLIENT_ID,
      authority: environment.TENANT_ID,
      redirectUri: environment.REDIRECT_URL
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfig {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

const ngxUiLoaderConfig: NgxUiLoaderConfig =
{
  "bgsColor": "red",
  "bgsOpacity": 0.5,
  "bgsPosition": "bottom-right",
  "bgsSize": 60,
  "bgsType": "ball-spin-clockwise",
  "blur": 5,
  "delay": 0,
  "fastFadeOut": true,
  "fgsColor": "red",
  "fgsPosition": "center-center",
  "fgsSize": 60,
  "fgsType": "ball-spin-clockwise",
  "gap": 24,
  "logoPosition": "center-center",
  "logoSize": 120,
  "logoUrl": "",
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(40, 40, 40, 0.8)",
  "pbColor": "red",
  "pbDirection": "ltr",
  "pbThickness": 3,
  "hasProgressBar": true,
  "text": "",
  "textColor": "#FFFFFF",
  "textPosition": "center-center",
  "maxTime": -1,
  "minTime": 300
}

@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        FooterComponent,
        HeaderComponent,
        // LoadRouteComponent,
        DocumentControlInquiryComponent,
        AddComplianceReviewComponent,
        BreadcrumbComponent,
        AddEditComplianceManagementComponent,
        AddContainerConsolidationComponent,
        UnAuthorizedComponent,
        AddBookingInfoComponent,
        WarningDialogComponent,
        AddLoadTypeComponent,
        EditLpRouteSystemComponent,
    ],
    bootstrap: [AppComponent],
    exports: [SharedModule], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatTabsModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        AgGridModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        SharedModule,
        FlexLayoutModule,
        NgIdleModule.forRoot()], providers: [Constants, DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useValue: {
                interactionType: InteractionType.Redirect
            } as MsalGuardConfiguration
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService, provideHttpClient(withInterceptorsFromDi()),] })
export class AppModule { }